<div class="container-fluid">
  <!-- Cabeçalho da página -->
  <div class="page-header">
    <h2>Cadastro de Clientes</h2>
  </div>

  <!-- Seção de filtros -->
  <div class="filter-section">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Nome:</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNome" (keyup)="aplicarFiltros()">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>CPF:</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCpf" (keyup)="aplicarFiltros()">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Tipo de Demanda:</label>
          <select class="form-control" [(ngModel)]="filtrotipO_DEMANDA" (change)="aplicarFiltros()">
            <option value="">Todos</option>
            <option value="jure_sanguinis">Jure Sanguinis</option>
            <option value="filho_menor">Filho Menor</option>
            <option value="outra_demanda">Outra Demanda</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>&nbsp;</label>
          <button class="btn btn-outline-secondary btn-block" (click)="limparFiltros()">
            <i class="fas fa-times"></i> Limpar Filtros
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela de clientes -->
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>CPF</th>
          <th>Email</th>
          <th>Telefone</th>
          <th>Tipo de Demanda</th>
          <th>Data de Cadastro</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cliente of clientesFiltrados | slice: pageIndex * pageSize : (pageIndex + 1) * pageSize">
          <td>{{cliente.nome}}</td>
          <td>{{cliente.cpf}}</td>
          <td>{{cliente.email}}</td>
          <td>{{cliente.telefone}}</td>
          <td>
            <span class="badge" [ngClass]="{
              'badge-success': cliente.tipO_DEMANDA === 'jure_sanguinis',
              'badge-warning': cliente.tipO_DEMANDA === 'filho_menor',
              'badge-info': cliente.tipO_DEMANDA === 'outra_demanda'
            }">
              {{gettipO_DEMANDALabel(cliente.tipO_DEMANDA)}}
            </span>
          </td>
          <td>{{cliente.datA_CADASTRO | date:'dd/MM/yyyy'}}</td>
          <td>
            <div class="btn-group">
              <button class="btn btn-sm btn-info" (click)="editarCliente(cliente); openModal(formModal)">
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn btn-sm btn-primary" (click)="carregarArquivos(cliente); openModal(arquivosModal)">
                <i class="fas fa-file"></i>
              </button>
              <button class="btn btn-sm btn-success" (click)="carregarArvore(cliente); openModal(arvoreModal)">
                <i class="fas fa-sitemap"></i>
              </button>
              <button class="btn btn-sm btn-warning" [routerLink]="['/chat']" [queryParams]="{clienteId: cliente.id}">
                <i class="fas fa-comments"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginação -->
  <div class="d-flex justify-content-between align-items-center mt-3">
    <div class="d-flex align-items-center">
      <span class="mr-2">Itens por página:</span>
      <select class="form-control form-control-sm" style="width: 70px" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="20">20</option>
        <option [value]="50">50</option>
      </select>
    </div>
    
    <div class="d-flex align-items-center">
      <span class="mr-2">
        {{pageIndex * pageSize + 1}}-{{min((pageIndex + 1) * pageSize, clientesFiltrados.length)}} de {{clientesFiltrados.length}}
      </span>
      <div class="btn-group">
        <button class="btn btn-outline-secondary" [disabled]="pageIndex === 0" (click)="onPageChange(pageIndex - 1)">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="btn btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="onPageChange(pageIndex + 1)">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de formulário -->
<ng-template #formModal>
  <div class="modal-header">
    <h4 class="modal-title">{{clienteSelecionado ? 'Editar' : 'Novo'}} Cliente</h4>
    <button type="button" class="close" (click)="modalRef.close()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Nome *</label>
            <input type="text" class="form-control" formControlName="nome" [ngClass]="{'is-invalid': cadastroForm.get('nome')?.invalid && cadastroForm.get('nome')?.touched}">
            <div class="invalid-feedback" *ngIf="cadastroForm.get('nome')?.invalid && cadastroForm.get('nome')?.touched">
              Nome é obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>CPF *</label>
            <input type="text" class="form-control" formControlName="cpf" [textMask]="{mask: cpfMask}" [ngClass]="{'is-invalid': cadastroForm.get('cpf')?.invalid && cadastroForm.get('cpf')?.touched}">
            <div class="invalid-feedback" *ngIf="cadastroForm.get('cpf')?.invalid && cadastroForm.get('cpf')?.touched">
              CPF inválido
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Email *</label>
            <input type="email" class="form-control" formControlName="email" [ngClass]="{'is-invalid': cadastroForm.get('email')?.invalid && cadastroForm.get('email')?.touched}">
            <div class="invalid-feedback" *ngIf="cadastroForm.get('email')?.invalid && cadastroForm.get('email')?.touched">
              Email inválido
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Telefone *</label>
            <input type="text" class="form-control" formControlName="telefone" [textMask]="{mask: telefoneMask}" [ngClass]="{'is-invalid': cadastroForm.get('telefone')?.invalid && cadastroForm.get('telefone')?.touched}">
            <div class="invalid-feedback" *ngIf="cadastroForm.get('telefone')?.invalid && cadastroForm.get('telefone')?.touched">
              Telefone é obrigatório
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Endereço *</label>
        <input type="text" class="form-control" formControlName="endereco" [ngClass]="{'is-invalid': cadastroForm.get('endereco')?.invalid && cadastroForm.get('endereco')?.touched}">
        <div class="invalid-feedback" *ngIf="cadastroForm.get('endereco')?.invalid && cadastroForm.get('endereco')?.touched">
          Endereço é obrigatório
        </div>
      </div>

      <div class="form-group">
        <label>Tipo de Demanda *</label>
        <select class="form-control" formControlName="tipO_DEMANDA" [ngClass]="{'is-invalid': cadastroForm.get('tipO_DEMANDA')?.invalid && cadastroForm.get('tipO_DEMANDA')?.touched}">
          <option value="">Selecione...</option>
          <option value="jure_sanguinis">Jure Sanguinis</option>
          <option value="filho_menor">Filho Menor</option>
          <option value="outra_demanda">Outra Demanda</option>
        </select>
        <div class="invalid-feedback" *ngIf="cadastroForm.get('tipO_DEMANDA')?.invalid && cadastroForm.get('tipO_DEMANDA')?.touched">
          Tipo de demanda é obrigatório
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="cadastroForm.invalid">Salvar</button>
  </div>
</ng-template>

<!-- Modal de arquivos -->
<ng-template #arquivosModal>
  <div class="modal-header">
    <h4 class="modal-title">Arquivos do Cliente</h4>
    <button type="button" class="close" (click)="modalRef.close()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="loading-spinner" *ngIf="loadingArquivos">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>

    <div class="arquivos-list" *ngIf="!loadingArquivos">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Nome do Arquivo</th>
             
              <th>Data de Upload</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let arquivo of arquivosCliente">
              <td>{{arquivo.nome}}</td>
         
              
              <td>{{arquivo.datA_CADASTRO | date:'dd/MM/yyyy HH:mm'}}</td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-sm btn-info" (click)="visualizarArquivo(arquivo)">
                    <i class="fas fa-eye"></i>
                  </button>
                  <!--<button class="btn btn-sm btn-danger" (click)="excluirArquivo(arquivo)">
                    <i class="fas fa-trash"></i>
                  </button>-->
                </div>
              </td>
            </tr>
            <tr *ngIf="arquivosCliente.length === 0">
              <td colspan="4" class="text-center">Nenhum arquivo encontrado</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">Fechar</button>
  </div>
</ng-template>

<!-- Modal da Árvore Hierárquica -->
<ng-template #arvoreModal>
  <div class="modal-header">
    <h4 class="modal-title">Árvore Genealógica</h4>
    <button type="button" class="close" (click)="modalRef.close()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="loading-spinner" *ngIf="loadingArvore">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>

    <div class="genealogical-tree" *ngIf="!loadingArvore">
      <div class="tree-container">
        <!-- Italiano/a -->
        <div class="tree-node root" *ngIf="arvoreCliente?.italiano">
          <div class="node-content">
            <div class="node-header">ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.italiano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.italiano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.italiano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.italiano.nomeConjuge || arvoreCliente.italiano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.italiano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.italiano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.italiano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.italiano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.italiano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.italiano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Filho/a do Italiano/a -->
        <div class="tree-node" *ngIf="arvoreCliente?.filhoItaliano && arvoreCliente?.parentesco !== 'filho'">
          <div class="node-content">
            <div class="node-header">FILHO/A DO/A ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.filhoItaliano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.filhoItaliano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.filhoItaliano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.filhoItaliano.nomeConjuge || arvoreCliente.filhoItaliano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.filhoItaliano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.filhoItaliano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.filhoItaliano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.filhoItaliano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.filhoItaliano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.filhoItaliano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Neto/a do Italiano/a -->
        <div class="tree-node" *ngIf="arvoreCliente?.netoItaliano && arvoreCliente?.parentesco !== 'filho' && arvoreCliente?.parentesco !== 'neto'">
          <div class="node-content">
            <div class="node-header">NETO/A DO/A ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.netoItaliano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.netoItaliano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.netoItaliano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.netoItaliano.nomeConjuge || arvoreCliente.netoItaliano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.netoItaliano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.netoItaliano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.netoItaliano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.netoItaliano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.netoItaliano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.netoItaliano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Bisneto/a do Italiano/a -->
        <div class="tree-node" *ngIf="arvoreCliente?.bisnetoItaliano && arvoreCliente?.parentesco !== 'filho' && arvoreCliente?.parentesco !== 'neto' && arvoreCliente?.parentesco !== 'bisneto'">
          <div class="node-content">
            <div class="node-header">BISNETO/A DO/A ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.bisnetoItaliano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.bisnetoItaliano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.bisnetoItaliano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.bisnetoItaliano.nomeConjuge || arvoreCliente.bisnetoItaliano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.bisnetoItaliano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.bisnetoItaliano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.bisnetoItaliano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.bisnetoItaliano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.bisnetoItaliano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.bisnetoItaliano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Trineto/a do Italiano/a -->
        <div class="tree-node" *ngIf="arvoreCliente?.trinetoItaliano && arvoreCliente?.parentesco !== 'filho' && arvoreCliente?.parentesco !== 'neto' && arvoreCliente?.parentesco !== 'bisneto' && arvoreCliente?.parentesco !== 'trineto'">
          <div class="node-content">
            <div class="node-header">TRINETO/A DO/A ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.trinetoItaliano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.trinetoItaliano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.trinetoItaliano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.trinetoItaliano.nomeConjuge || arvoreCliente.trinetoItaliano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.trinetoItaliano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.trinetoItaliano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.trinetoItaliano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.trinetoItaliano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.trinetoItaliano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.trinetoItaliano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Tetraneto/a do Italiano/a -->
        <div class="tree-node" *ngIf="arvoreCliente?.tetranetoItaliano && arvoreCliente?.parentesco !== 'filho' && arvoreCliente?.parentesco !== 'neto' && arvoreCliente?.parentesco !== 'bisneto' && arvoreCliente?.parentesco !== 'trineto' && arvoreCliente?.parentesco !== 'tetraneto'">
          <div class="node-content">
            <div class="node-header">TETRANETO/A DO/A ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.tetranetoItaliano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.tetranetoItaliano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.tetranetoItaliano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.tetranetoItaliano.nomeConjuge || arvoreCliente.tetranetoItaliano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.tetranetoItaliano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.tetranetoItaliano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.tetranetoItaliano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.tetranetoItaliano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.tetranetoItaliano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.tetranetoItaliano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Pentaneto/a do Italiano/a -->
        <div class="tree-node" *ngIf="arvoreCliente?.pentanetoItaliano && arvoreCliente?.parentesco !== 'filho' && arvoreCliente?.parentesco !== 'neto' && arvoreCliente?.parentesco !== 'bisneto' && arvoreCliente?.parentesco !== 'trineto' && arvoreCliente?.parentesco !== 'tetraneto' && arvoreCliente?.parentesco !== 'pentaneto'">
          <div class="node-content">
            <div class="node-header">PENTANETO/A DO/A ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.pentanetoItaliano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.pentanetoItaliano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.pentanetoItaliano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.pentanetoItaliano.nomeConjuge || arvoreCliente.pentanetoItaliano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.pentanetoItaliano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.pentanetoItaliano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.pentanetoItaliano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.pentanetoItaliano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.pentanetoItaliano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.pentanetoItaliano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Hexaneto/a do Italiano/a -->
        <div class="tree-node" *ngIf="arvoreCliente?.hexanetoItaliano && arvoreCliente?.parentesco !== 'filho' && arvoreCliente?.parentesco !== 'neto' && arvoreCliente?.parentesco !== 'bisneto' && arvoreCliente?.parentesco !== 'trineto' && arvoreCliente?.parentesco !== 'tetraneto' && arvoreCliente?.parentesco !== 'pentaneto' && arvoreCliente?.parentesco !== 'hexaneto'">
          <div class="node-content">
            <div class="node-header">HEXANETO/A DO/A ITALIANO/A</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente.hexanetoItaliano.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente.hexanetoItaliano.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente.hexanetoItaliano.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.hexanetoItaliano.nomeConjuge || arvoreCliente.hexanetoItaliano.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente.hexanetoItaliano.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente.hexanetoItaliano.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente.hexanetoItaliano.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente.hexanetoItaliano.dataObito">
                  <p><strong>Data do Óbito:</strong> {{arvoreCliente.hexanetoItaliano.dataObito | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local do Óbito:</strong> {{arvoreCliente.hexanetoItaliano.localObito}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tree-branch"></div>
        </div>

        <!-- Cliente -->
        <div class="tree-node">
          <div class="node-content">
            <div class="node-header">VOCÊ ({{getParentescoLabel(arvoreCliente?.parentesco)}})</div>
            <div class="node-body">
              <div class="node-info">
                <p><strong>Nome:</strong> {{arvoreCliente?.cliente?.nomeCompleto}}</p>
                <p><strong>Data de Nascimento:</strong> {{arvoreCliente?.cliente?.dataNascimento | date:'dd/MM/yyyy'}}</p>
                <p><strong>Local de Nascimento:</strong> {{arvoreCliente?.cliente?.localNascimento}}</p>
                <div class="additional-info mt-3" *ngIf="arvoreCliente?.cliente?.nomeConjuge || arvoreCliente?.cliente?.dataCasamento">
                  <p><strong>Cônjuge:</strong> {{arvoreCliente?.cliente?.nomeConjuge}}</p>
                  <p><strong>Data de Casamento:</strong> {{arvoreCliente?.cliente?.dataCasamento | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Local de Casamento:</strong> {{arvoreCliente?.cliente?.localCasamento}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente?.cliente?.filhos">
                  <p><strong>Filhos:</strong> {{arvoreCliente?.cliente?.filhos}}</p>
                </div>
                <div class="additional-info mt-3" *ngIf="arvoreCliente?.cliente?.netos">
                  <p><strong>Netos:</strong> {{arvoreCliente?.cliente?.netos}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">Fechar</button>
  </div>
</ng-template> 